module.exports = __webpack_public_path__ + "static/adjustable-base-curved-31b27659b0704739f72cb244779fa6b7.jpeg";